import "ngstorage";

class TeamsController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    TeamsService,
    CompaniesService,
    SecurityService,
    $stateParams,
    CommonService,
    $rootScope,
    EnvService,
    $timeout,
    $location
  ) {
    this.name = "teams";
    $localStorage.activeStateName = "teams";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$teams = TeamsService;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$stateParams = $stateParams;
    this.$common = CommonService;
    this.$rootScope = $rootScope;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.pages = [];
    this.currentUser = this.$auth.getUserData();
    this.currentPageNumber = 1;
    this.pagesForTeams = [];
    this.query = "";
    this.uiViews = {};
    this.uiViews.is_loading = true;
    this.currentTeam = {}; // for update or delete the team
    this.cloudName = "";
    this.cloudParticipants = "";
    this.cloudDescription = "description";
    this.removeJobblersList = [];
    this.$location = $location;
    this.disableTeamCreationForm = true;
    this.jobblersNotAdded = [];
    this.jobblersAdded = [];
    this.jobblersAlready = [];
    this.calculatePagination();
    this.create_team = {
      name: "",
      jobbler_emails: "",
    };

    this.remain_loading_count = 1;

    var _this = this;

    if (_this.$rootScope.teams) {
      _this.teams = _this.$rootScope.teams;
      this.remain_loading_count = 0;
    }

    /*
    _this.$timeout(function() {
    	jQuery('#show-added-jobblers').trigger('click');
    }, 100);
    */

    _this.$rootScope.$on("TeamsHaveLoaded", function ($event, params) {
      _this.remain_loading_count = 0;
      _this.teams = params.teams;
    });

    _this.$timeout(function () {
      $("jobbleheader .main-menu ul li:nth-child(4)").removeClass().addClass("active");
    });

    _this.loadTeams();
  }

  clickMagnify() {
    _this.$timeout(function () {
      jQuery(".search-container").addClass("s-open");
      jQuery(".search-container").find('input[type="search"]').focus();
    });
  }

  closeSearch() {
    _this.$timeout(function () {
      jQuery(".search-container").removeClass("s-open");
      this.query = "";
    });
  }

  calculatePagination() {
    this.pagesForTeams = [];
    if (this.$security.isUndefinedOrNull(this.currentUser.company)) {
      this.pagesForTeams.push(1);
    } else {
      var numberOfTeams = Math.ceil(this.currentUser.company.totalNumberOfCircles / 10);
      if (numberOfTeams > 1) {
        for (var i = 0; i < numberOfTeams; i++) {
          this.pagesForTeams.push(i + 1);
        }
      }
    }
  }

  setAvatarImageToUsersOfTeam(team) {
    var _this = this;
    team.users.forEach(function (userProfile) {
      userProfile.pictureAvatarUrl = userProfile.filePROFILE_IMAGE1IMG_75x75;
      if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
        userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
      }
    });
  }

  clickViewMore($event, team) {
    var _this = this;
    if (team.isAllUsersLoaded) {
      _this.$timeout(function () {
        jQuery($event.currentTarget).hide();
        jQuery($event.currentTarget).closest(".team-row").find(".hide-item").css("display", "inline-block");
      });
      return;
    }

    var url =
      _this.$env.getAPIEndPoint() +
      "jbl/v1/circles/" +
      team.id +
      "/users?format=json&fields=id,firstName,lastName,filePROFILE_IMAGE1IMG_75x75&offset=0&sort=email&order=asc&max=" +
      team.numberOfUsers;
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {},
    };

    _this.remain_loading_count++;
    _this.$http(req).then(
      function (response) {
        _this.remain_loading_count--;
        if (response.data.status === "error") {
          console.log("error to get the team users");
        }
        team.userProfiles = response.data;
        _this.setAvatarImageToUsersOfTeam(team);
        team.isAllUsersLoaded = true;
        _this.$timeout(function () {
          jQuery($event.currentTarget).hide();
          jQuery($event.currentTarget).closest(".team-row").find(".hide-item").css("display", "inline-block");
        });
      },
      function (response) {
        _this.remain_loading_count--;
        console.log(response.data);
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  clickUpBtn($event) {
    // jQuery('.hide-item').hide();
    // jQuery('.view-more').css('display','inline-block');

    jQuery($event.currentTarget).closest(".team-row").find(".hide-item").hide();
    jQuery($event.currentTarget).closest(".team-row").find(".view-more").css("display", "inline-block");
  }

  setCurrentTeam(team) {
    // this.currentTeam = team;

    this.isAddNewJobblersError = undefined;
    this.emailsToAdd = undefined;

    this.currentTeam = jQuery.extend(true, {}, team);
    this.selectedTeam = team;
    this.removeJobblersList = [];
    console.log(this.currentTeam);
  }

  paginateUsers(offset) {
    var _this = this;
    console.log("paginate");
    console.dir(_this.currentTeam);
    console.dir(offset);
    _this.currentPageNumber = offset;

    if (offset !== 0) {
      offset = offset * 12 - 12;
    }

    var url =
      _this.$env.getAPIEndPoint() +
      "jbl/v1/circles/" +
      _this.currentTeam.id +
      "/users?format=json&fields=id,firstName,lastName,filePROFILE_IMAGE1IMG_75x75&sort=email&order=asc&max=12&offset=" +
      offset;
    var req = {
      method: "GET",
      url: url,
      headers: {
        authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {},
    };

    _this.remain_loading_count++;
    _this.$http(req).then(
      function (response) {
        _this.remain_loading_count--;
        if (response.data.status === "error") {
          console.log("error to get the team users");
        }

        console.log("here is the user data...");
        console.dir(response.data);
        try {
          response.data.forEach(function (userProfile) {
            if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
              userProfile.picture1s.forEach(function (pic) {
                if (pic.indexOf("75x75") > -1) {
                  userProfile.pictureAvatarUrl = pic;
                }
                if (pic.indexOf("160x160") > -1) {
                  userProfile.pictureAvatarUrlBig = pic;
                }
              });
            }

            if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
              userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
            }
            if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
              userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
            }
          });
        } finally {
          _this.userProfilesForPagination = response.data;
        }
      },
      function (response) {
        _this.remain_loading_count--;
        console.log(response.data);
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  loadJobblers(team, index) {
    console.log("load jobblers");
    console.dir(team);
    console.dir(index);
    var offset = index;
    var _this = this;
    console.log("whats the team");
    _this.currentTeam = team;
    console.dir(_this.currentTeam);

    try {
      var pageArray = [];
      for (var i = 0; i < Math.ceil(team.numberOfUsers / 12); i++) {
        pageArray.push(i + 1);
        _this.pages = pageArray;
      }
    } finally {
      if (offset !== 0) {
        offset = offset * 12 - 12;
      }

      _this.currentPageNumber = 1;

      var url =
        _this.$env.getAPIEndPoint() +
        "jbl/v1/circles/" +
        team.id +
        "/users?format=json&fields=id,firstName,lastName,email,filePROFILE_IMAGE1IMG_75x75&sort=email&order=asc&max=12&offset=" +
        offset;

      var req = {
        method: "GET",
        url: url,
        headers: {
          authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {},
      };

      _this.remain_loading_count++;
      _this.$http(req).then(
        function (response) {
          if (response.data.status === "error") {
            alert("Error retrieving jobblers.");
          }

          console.log("here is the user data...");
          console.dir(response.data);

          try {
            response.data.forEach(function (userProfile) {
              if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
                userProfile.picture1s.forEach(function (pic) {
                  if (pic.indexOf("75x75") > -1) {
                    userProfile.pictureAvatarUrl = pic;
                  }
                  if (pic.indexOf("160x160") > -1) {
                    userProfile.pictureAvatarUrlBig = pic;
                  }
                });
              }

              if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
                userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
              }
              if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
                userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
              }
            });
          } finally {
            _this.$timeout(function () {
              _this.userProfilesForPagination = response.data;
              jQuery("#modal-team-edit-anchor").trigger("click");
            });

            _this.$timeout(function () {
              _this.remain_loading_count--;
            }, 200);
          }
        },
        function (response) {
          _this.remain_loading_count--;
          console.log(response.data);
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    }
  }

  createTeamModal() {
    var _this = this;

    _this.$timeout(function () {
      jQuery("#modal-create-team").modal();
    }, 100);
  }

  createTeam() {
    this.$teams.createTeam(this.create_team).then(
      function (data) {
        console.log("success");
      },
      function (data) {
        console.log("error");
      }
    );
  }

  keepTeam($event) {
    jQuery($event.currentTarget).closest("#modal-del-team").find("button.close").trigger("click");
  }

  addJobblersToTeam($event) {
    jQuery($event.currentTarget).closest("#modal-add-jobbler").find("button.close").trigger("click");
  }

  removeJobblerFromTeam($index, $event) {
    // jQuery($event.currentTarget).parent().remove();
    this.currentTeam.userProfiles.splice($index, 1);
  }

  createCloud() {
    var _this = this;
    _this.addNewCloud = true;
    _this.isCreateTeamError = false;
  }

  validateTeamForm() {
    if (this.cloudName.length > 2) {
      this.disableTeamCreationForm = false;
    } else {
      this.disableTeamCreationForm = true;
    }
  }

  submitNewCloud(emails, id) {
    var _this = this;
    _this.isCreateTeamError = false;
    let cloudObj = {};
    cloudObj.name = _this.cloudName;
    cloudObj.description = _this.cloudDescription;
    let pl = {};
    if (emails) {
      cloudObj.id = id;
      pl.users = emails;
      pl.circle = cloudObj;
    } else {
      pl.users = "";
      pl.circle = cloudObj;
    }
    if (_this.$security.isUndefinedOrNull(_this.cloudName) || _this.$security.isUndefinedOrNull(_this.cloudDescription)) {
      _this.isCreateTeamError = true;
      _this.createTeamErrorMessage = "Please fill out all fields.";
    } else {
      _this.showFillOutAllFieldsWarning = false;
      let str = _this.cloudParticipants.replace(/[\s,]+/g, ", ");
      var commaSeparatedListTest = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/.test(str);

      if (commaSeparatedListTest || str.length === 0) {
        var saveCloud = {
          method: "POST",
          url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/add-to-circle?format=json&conf=web&verbosity=4",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + _this.currentUser.access_token,
          },
          data: pl,
        };
        _this.remain_loading_count++;
        _this.$http(saveCloud).then(
          function (response) {
            _this.isCreateTeamError = false;
            if (response.status === 200 && response.data.status === "OK") {
              _this.$auth.reloadCurrentUser();
              if (emails || str.length === 0) {
                //_this.remain_loading_count--;
                _this.handleModal(response);
              } else {
                _this.$timeout(function () {
                  let id = response.data.result.circle.id;
                  _this.submitNewCloud(str, id);
                }, 2000);
              }
            } else {
              _this.cloudName = null;
              _this.cloudDescription = null;
              _this.cloudParticipants = null;
              _this.subview = false;
              _this.submitNewCloudLoader = false;
              _this.remain_loading_count--;
              _this.$timeout(function () {
                alert("There was an issue creating this team. Please contact support.");
              }, 300);
            }
          },
          function (response) {
            _this.remain_loading_count--;
            _this.$timeout(function () {
              jQuery("#show-application-alert").trigger("click");
            }, 100);
          }
        );
      } else {
        _this.isCreateTeamError = true;
        _this.createTeamErrorMessage = "Please make sure your emails are in a comma separated list, and that your emails are formatted properly.";
      }

    }
  }

  handleModal(response) {
    var _this = this;
    console.log("handling response");
    _this.remain_loading_count = 0;
    _this.jobblersAdded = response.data.result.added;
    _this.jobblersNotAdded = response.data.result.notAdded;
    _this.jobblersAlready = response.data.result.already;
    _this.setNewTeamToList(response);
    _this.cloudName = "";
    _this.cloudParticipants = "";
    _this.$timeout(function () {
      jQuery("#modal-create-team .modal-header button.close").trigger("click");
    }, 100);
    _this.$timeout(function () {
      jQuery("#show-added-jobblers").trigger("click");
    }, 300);
  }

  submitNewJobblers() {
    var _this = this;

    _this.isAddNewJobblersError = false;

    if (!_this.$security.isUndefinedOrNull(_this.emailsToAdd)) {
      var str = _this.emailsToAdd.replace(/[\s,]+/g, ", ");

      var commaSeparatedListTest = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/.test(str);

      if (commaSeparatedListTest) {
        var updateCloud = {
          method: "POST",
          url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/add-to-circle?format=json&conf=web",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + _this.currentUser.access_token,
          },
          data: {
            users: str,
            circle: _this.currentTeam.id,
          },
        };

        _this.remain_loading_count++;

        _this.$http(updateCloud).then(
          function (response) {
            if (response.status === 200) {
              if (response.data.status == "OK") {
                _this.isAddNewJobblersError = false;
                _this.emailsToAdd = null;

                _this.jobblersAdded = response.data.result.added;
                _this.jobblersNotAdded = response.data.result.notAdded;
                _this.jobblersAlready = response.data.result.already;

                jQuery("#modal-add-jobbler .modal-header button.close").trigger("click");

                _this.$timeout(function () {
                  jQuery("#show-added-jobblers").trigger("click");
                }, 100);
              } else {
                alert("There was an error. Please contact support to solve the issue.");
                // _this.isAddNewJobblersError = true;
                // _this.addNewJobblersErrorMessage = "The emails is not valid or already added.";
              }
            } else {
              console.log("in error");
              console.dir(response);
            }

            _this.remain_loading_count--;
          },
          function (response) {
            _this.remain_loading_count--;
            _this.$timeout(function () {
              jQuery("#show-application-alert").trigger("click");
            }, 100);
          }
        );
      } else {
        _this.isAddNewJobblersError = true;
        _this.addNewJobblersErrorMessage = "Please make sure your emails are in a comma separated list, and that your emails are formatted properly.";
      }
    } else {
      _this.isAddNewJobblersError = true;
      _this.addNewJobblersErrorMessage = "Please fill out the emails field.";
    }
  }

  removeJobblerFromCloud($index, $event, user) {
    var _this = this;
    console.log("what is the user");
    console.dir(user);
    _this.removeJobblersList.push(_this.userProfilesForPagination[$index].email);
    _this.userProfilesForPagination.splice($index, 1);
    console.dir(_this.userProfilesForPagination);
    //_this.removeJobblersList.push(_this.currentTeam.userProfiles[$index].email);
    console.dir("what is the curren tteam");
    console.dir(_this.currentTeam.id);
    var removeFromCloud = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/remove-from-circle?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {
        users: user.email,
        circle: _this.currentTeam.id,
      },
    };

    _this.$http(removeFromCloud).then(
      function (response) {
        console.log("response");
        console.dir(response);
      },
      function (error) {
        console.log("error");
        console.dir(error);
      }
    );

    return;

  }

  paginate(pageNumber) {

    if (pageNumber < 1 || pageNumber > this.pagesForTeams.length) {
      return;
    }

    this.currentPageNumber = pageNumber;
    this.remain_loading_count = 1;

    var companyId = this.currentUser.company.id;
    var offsetParam = pageNumber * 10 - 10,
      maxParam = 10,
      sort = "lastUpdated",
      order = "desc";

    var _this = this;
    this.$companies.paginateThroughTeams(companyId, offsetParam, maxParam, sort, order).then(
      function (data) {
        console.log("what is the response form pagination");
        console.dir(data);

        _this.teams = data.data;
        _this.teams.forEach(function (team, index) {
          _this.setAvatarImageToUsersOfTeam(team);
          team.firstLoadUsersCount = Math.min(team.users.length, 6);
          if (team.firstLoadUsersCount == 6) {
            team.firstLoadUsersCount = 5;
          }
        });

        _this.remain_loading_count--;
      },
      function (data) {
        console.log(data);
        _this.remain_loading_count--;
      }
    );
  }

  updateTeamMembers() {
    var _this = this;

    if (_this.removeJobblersList.length > 0) {
      var removeFromCloud = {
        method: "POST",
        url: _this.$env.getAPIEndPoint() + "jbl/v1/companies/" + _this.currentUser.company.id + "/remove-from-circle?format=json&conf=web",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {
          users: _this.removeJobblersList.join(),
          circle: _this.currentTeam.id,
        },
      };
      _this.remain_loading_count++;
      _this.$http(removeFromCloud).then(
        function (response) {
          _this.remain_loading_count--;
          if (response.status === 200) {
            if (response.data.status == "OK" && response.data.result.removed.length > 0) {
              _this.loadTeams();
            }
          }

          jQuery("#modal-edit-team .modal-header button.close").trigger("click");
        },
        function (response) {
          _this.remain_loading_count--;
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    }
  }

  deleteCloud() {
    var _this = this;

    _this.remain_loading_count++;
    var deletingCloud = {
      method: "DELETE",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/circles/" + _this.currentTeam.id + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
    };

    _this.$http(deletingCloud).then(
      function (response) {
        if ((response.status = 200)) {
          var delIndex;
          _this.teams.forEach(function (team, index) {
            if (_this.currentTeam.id === team.id) {
              delIndex = index;
            }
          });
          _this.teams.splice(delIndex, 1);
          _this.$auth.reloadCurrentUser();
        } else {

        }
        _this.remain_loading_count--;
        jQuery("#modal-del-team .modal-header button.close").trigger("click");
      },
      function (response) {
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  displayDetails(userProfile, type, action) {
    var applicant = {
      applicant: userProfile,
      jobble: {
        eventId: this.$stateParams.eventId,
      },
    };
    this.$common.displayDetails(applicant, type, action);
    this.$rootScope.$emit("GetJobblerDataFromService", {});
  }

  goToProfile(jobbler) {

    var _this = this;

    _this.$timeout(function () {
      _this.$location.path("/profiles/").search({id: jobbler.id});
      //_this.$state.go('profiles');
      //_this.$rootScope.$emit("SetJobblerProfile", { jobbler : jobbler });
    }, 300);
  }

  loadTeams() {
    var _this = this;
    var teamsSimple = [];
    var teams = [];
    _this.$companies.getTeamsTrim().then(
      function (data) {
        console.log("what is returned from get Teams");
        console.dir(data);
        try {
          data.data.forEach(function (team, index) {
            _this.setAvatarImageToUsersOfTeam(team);
            team.firstLoadUsersCount = Math.min(team.users.length, 6);
            if (team.firstLoadUsersCount == 6) {
              team.firstLoadUsersCount = 5;
            }
            teams.push(team);
            var teamsObj = {};
            teamsObj.name = team.name;
            teamsObj.id = team.id;
            teamsSimple.push(teamsObj);
          });
        } finally {
          _this.teams = teams;
          _this.remain_loading_count = 0;
          _this.uiViews.is_loading = false;
        }
      },
      function (data) {
        _this.$rootScope.teams = [];
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  setNewTeamToList(response) {
    var _this = this;
    let team = {};
    team.id = response.data.result.circle.id;
    team.name = response.data.result.circle.name;
    team.numberOfUsers = response.data.result.added.length;

    let id_to_add = team.id;
    //call function by date created to get the new circle and add in the thumbnails

    _this.teams.push(team);
  }

  updateTeam() {
    var _this = this;
    console.log("saving team");
    let circle = {
      id: _this.currentTeam.id,
      name: _this.currentTeam.name,
    };

    var editFromCloud = {
      method: "PUT",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/companies/" +
        _this.currentUser.company.id +
        "/circles/" +
        _this.currentTeam.id +
        "?name=" +
        circle.name,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
    };
    _this.remain_loading_count++;
    _this.$http(editFromCloud).then(
      function (response) {
        _this.remain_loading_count--;
        if (response.status === 200) {
          _this.loadTeams();
          jQuery("#modal-edit-team .modal-header button.close").trigger("click");
        } else {
          _this.remain_loading_count--;
          _this.$timeout(function () {
            alert("There was an issue creating this team. Please contact support.");
          }, 300);
        }
      },
      function (response) {
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
    this.updateTeamMembers();
  }

  setTeamNameForDetailsPage(team) {
    var _this = this;
    _this.$location.path("/teams/" + team.id).search({name: team.name, numberOfUsers: team.numberOfUsers});
  }

  toggleActionMenu(job, index) {
    var _this = this;

    let i = index + 1;

    _this.$timeout(function () {
      $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({duration: 100});
    });

    _this.$timeout(function () {
      $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td").addClass("row-focus");
    }, 150);

    _this.$timeout(function () {
      $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
    }, 300);
  }

  closeActionMenu(job, index) {
    var _this = this;

    let i = index + 1;

    _this.$timeout(function () {
      $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td:last-child .action-menu").hide();
      $("table.jobble-table.teams tbody tr:nth-child(" + i + ") td").removeClass("row-focus");
    }, 150);
  }

  addUser(team, index) {
    this.setCurrentTeam(team);
    this.$timeout(() => {
      $("#modal-add-jobbler").modal();
    });
  }

  editTeam(team, index) {
    this.setCurrentTeam(team);
    this.loadJobblers(team, 0);
    this.$timeout(() => {
      $("#modal-edit-team").modal();
    });
  }

  deleteTeam(team, index) {
    this.setCurrentTeam(team);
    this.$timeout(() => {
      $("#modal-del-team").modal();
    });
  }
}

TeamsController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "teams",
  "companies",
  "security",
  "$stateParams",
  "common",
  "$rootScope",
  "env",
  "$timeout",
  "$location",
];

export default TeamsController;



// WEBPACK FOOTER //
// ./client/app/components/teams/teams.controller.js